<script lang="ts">
    import { VpInformationIcon } from '@decathlon-experience/icons/svelte';

    import { trans } from '$assets/shop-translator.js';
</script>

<div
    class="flex items-center gap-xs gap-x-2 rounded-lg bg-commercial-neutral p-s text-xs text-content-brand"
>
    <span><VpInformationIcon size={12} /></span>
    <span>{trans('tour.aside_panel.travelgate.infobox')}</span>
</div>
